export const BANK_ACCOUNT_TYPE = "בנק" as const;
export const BANKS_PATH = "/banks";
export const BANKS_BREADCRUMB = { ledger: "כרטסות", list: "בנקים" } as const;
export const BANKS_STRUCTURE_CRUMBS = {
  browse: "הגדרת מבנה דפדוף",
} as const;